import {
  IServiceEnablementResponse,
  IServiceEnablementUpdate
} from "@wingspanhq/benefits/dist/src/lib/interfaces";
import { benefitsService } from "./benefitsService";

export const updateBenefitsService = async (
  userId: string,
  data: IServiceEnablementUpdate
): Promise<IServiceEnablementResponse> => {
  const response = await benefitsService.patch(`/service/${userId}`, data);
  return response.data;
};
